import { Loader2 } from "lucide-react";
import { SharedUserItem } from "./SharedUserItem";
import { useSharedUsers } from "@/hooks/use-shared-users";

interface SharedUsersListProps {
  assetId?: number;
  placeId?: number;
  companyId?: number;
}

export function SharedUsersList({ assetId, placeId, companyId }: SharedUsersListProps) {
  const { sharedUsers, isLoading, revokeAccess } = useSharedUsers({ assetId, placeId, companyId });

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-4">
        <Loader2 className="h-6 w-6 animate-spin" />
      </div>
    );
  }

  if (!sharedUsers?.length) {
    return (
      <p className="text-sm text-muted-foreground py-2">
        This {assetId ? 'asset' : placeId ? 'place' : 'company'} hasn't been shared with anyone yet.
      </p>
    );
  }

  return (
    <div className="space-y-4">
      <h3 className="text-sm font-medium">Shared with:</h3>
      <div className="space-y-2">
        {sharedUsers.map((share) => (
          <SharedUserItem
            key={share.shared_with}
            email={share.shared_with_profile?.email}
            sharedAt={share.shared_at}
            onRevoke={() => revokeAccess.mutate(share.shared_with)}
            isRevoking={revokeAccess.isPending}
          />
        ))}
      </div>
    </div>
  );
}